/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvNameLabel}}</label>
                  <input
                    v-model="vmGPathCareerInterFormData.name"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle1">
                    {{cvTitle1Label}}</label>
                  <input
                    v-model="vmGPathCareerInterFormData.title1"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle2">
                    {{cvTitle2Label}}</label>
                  <input
                    v-model="vmGPathCareerInterFormData.title2"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdescription">
                    {{cvDescriptionLabel}}</label>
                  <textarea
                    v-model="vmGPathCareerInterFormData.description"
                    type="text"
                    class="textarea form-control"
                    required
                  ></textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationimage">
                    {{cvImageLabel}}</label>
                  <input
                    v-model="vmGPathCareerInterFormData.image"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcolor_code">
                    {{cvColorCodeLabel}}</label>
                  <input
                    v-model="vmGPathCareerInterFormData.color_code"
                    type="text"
                    class="form-control"
                    required/>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="gpath_career_interAdd()">
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { GPathCareerInters } from "../../../FackApi/api/GPathCareerInter"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "GPathCareerInterAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      apiName: "gpath_careers_inter_add",
      cvCardTitle: "Add GPaths Career Inter",
      cvCardSubHeader: "Add GPaths Career Inter ",
      cvSubmitBtn: "Add",
      cvNameLabel: "name",
      cvTitle1Label: "title1",
      cvTitle2Label: "title2",
      cvDescriptionLabel: "description",
      cvImageLabel: "image",
      cvColorCodeLabel: "color code",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "GPathCareerInter Add Response",
      vmGPathCareerInterFormData: Object.assign({}, this.initFormData()),
      vmGPathCareerInterDesc: null,
      vmGPathCareerInterType: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "name": "",
        "title1": "",
        "title2": "",
        "description": "",
        "image": "",
        "color_code": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGPathCareerInterFormData) {
          if (!this.vmGPathCareerInterFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_interAdd
     */
    async gpath_career_interAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        let gpathCareerInterAddResp = await GPathCareerInters.gpath_career_interAdd(this, this.vmGPathCareerInterFormData)
        await ApiResponse.responseMessageDisplay(this, gpathCareerInterAddResp)
        if (gpathCareerInterAddResp && !gpathCareerInterAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathCareerInterAddModal", gpathCareerInterAddResp.resp_data)
        }
        this.vmGPathCareerInterFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_interAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
